export const languageSet = {
  es: ['ca', 'gl', 'eu'], // Catalan, Galician, Basque
  en_ph: ['fil', 'ceb', 'ilo', 'hil'], // Filipino, Cebuano, Iloko, Hiligaynon (not exhaustive)
  en_my: ['ms'], // Malay
  it: ['sc'], // Sardinian
}
